import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  const checkpoints = ['Accurate for the latest targeted Laravel version', 'Unambiguous (clear wording, no "gotcha" answers)', 'Practically relevant to real-world Laravel development', 'Aligned to the intended level (Junior / Mid / Senior / Artisan)', 'Supported by correct code samples and verified solutions'];
  return <div className="w-full max-w-6xl mx-auto px-4 py-12 md:py-20" data-id="element-113">
      <h1 className="font-display font-extrabold text-4xl md:text-6xl text-gray-900 text-center mb-10 md:mb-14" data-id="element-114">
        Built in Partnership with the{' '}
        <span className="text-laravel-red" data-id="element-115">Laravel</span> community
      </h1>
      <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16" data-id="element-116">
        {/* Left - Illustration */}
        <div className="w-full md:w-5/12 flex justify-center" data-id="element-117">
          <img src="https://cdn.magicpatterns.com/uploads/8uBSWiKaZi68jSi1bWG7ZU/Untitled_design_(5).png" alt="Laravel Developer Illustration" className="w-full max-w-xs md:max-w-sm object-contain" data-id="element-118" />
        </div>

        {/* Right - Content */}
        <div className="w-full md:w-7/12" data-id="element-119">
          <p className="text-gray-700 leading-relaxed mb-6" data-id="element-120">
            Examination question sets and coding challenges are developed and
            peer-reviewed by a global team of Laravel practitioners. CFL is
            community-driven (100+ contributors worldwide) with a structured
            review process to ensure every question is:
          </p>

          <ul className="space-y-3 mb-6" data-id="element-121">
            {checkpoints.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-122">
                <CheckCircle2 className="w-5 h-5 text-laravel-red shrink-0 mt-0.5" data-id="element-123" />
                <span className="text-gray-700 font-medium" data-id="element-124">{item}</span>
              </li>)}
          </ul>

          <p className="text-gray-700 leading-relaxed mb-6" data-id="element-125">
            This community model ensures the certification validates
            competencies that matter in production Laravel work, architecture
            decisions, framework fundamentals, and day-to-day problem solving.
          </p>

          <p className="text-gray-900 font-bold text-lg" data-id="element-126">
            Since 2018 CFL has certified 3500{' '}
            <span className="text-laravel-red" data-id="element-127">Laravel</span> developers (as of
            2025).
          </p>
        </div>
      </div>
    </div>;
}